export default __webpack_public_path__ + "static/media/dragon.dcadbc5e.png";